export const PAGINATOR_TEMPLATE =
  'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown';

export const PAGINATOR_ROWS_PER_PAGE = [10, 25, 50];
export const PAGINATOR_ROWS = 10;
